import { useEffect, useState, useRef } from 'react'
import { omit } from 'lodash'
// import { useStaticQuery, graphql } from 'gatsby'
// import Hubspot from 'hubspot'

// const hubspot = new Hubspot({})

// export const useHubspot = () => {
//   return hubspot
// }

export const useComponentVisible = (initialIsVisible, lockBody = false) => {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible)
  const ref = useRef(null)

  const handleHideDropdown = (event) => {
    if (event.key === 'Escape') {
      setIsComponentVisible(false)
    }
  }

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false)
    }
  }

  useEffect(() => {
    if (lockBody) {
      if (isComponentVisible) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'visible'
      }
    }
  }, [isComponentVisible])

  useEffect(() => {
    document.addEventListener('keydown', handleHideDropdown, true)
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('keydown', handleHideDropdown, true)
      document.removeEventListener('click', handleClickOutside, true)
    }
  })

  return { ref, isComponentVisible, setIsComponentVisible }
}

export const useFocus = () => {
  const ref = useRef(null)
  const [isFocused, setIsFocused] = useState()
  const setFocus = () => {
    ref.current && ref.current.focus()
  }

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setIsFocused(false)
  }

  useEffect(() => {
    const reference = ref.current
    reference && reference.addEventListener('focusin', handleFocus, true)
    reference && reference.addEventListener('focusout', handleBlur, true)
    return () => {
      reference && reference.removeEventListener('focusin', handleFocus, true)
      reference && reference.removeEventListener('focusout', handleBlur, true)
    }
  })

  return { ref, isFocused, setFocus }
}

export const useDocumentScroll = () => {
  const setIsScrollStopped = (turnOn) => {
    if (turnOn) {
      document.body.classList.add('stop-scroll')
    } else {
      document.body.classList.remove('stop-scroll')
    }
  }
  useEffect(() => {
    return () => {
      document.body.classList.remove('stop-scroll')
    }
  }, [])
  return setIsScrollStopped
}

export const useFormValidation = () => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({})
  
  const handleChange = (event) => {
    let name = event.target.name;
    let val = event.target.value;

    validateForm(event, name, val)

    setValues({
      ...values, 
      [name]:val
    })
  }

  const validateForm = (event, name, value) => {
    switch (name) {
      case 'email':
        if (!value.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) && value !== "") {
          setErrors({
            ...errors, 
            email:'Please type a valid email address'
          })
          // setErrors(errors)
        } else {
          let newErrors = omit(errors, 'email')
          setErrors(newErrors)
        }
        break;
      default: 
        break;
    }
  }

  return {
    values, 
    errors, 
    handleChange
  }

}

